import React, { useState, useMemo, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisVertical,
  faPlus,
  faEdit,
  faArchive,
  faBoxOpen,
  faSync,
  faDownload,
  faFileCsv,
  faFileExcel,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getListOfChildrensInKG, getBenefitsListKG, getBenefits } from './actions';
import '../QueueFull/cabinet-zdo-requests.css';
import './staff-schedule.css';

import StatisticaAttendance from '../TabelGroup/StatisticaAttendanceGroup';

const cor2Float = (a)=>parseFloat(a.toFixed(2));

const ListChildrenSKG = ( { 
  kindergartenId,
  groups,
  onActionSelect
} ) => {
  const [activeTab, setActiveTab] = useState('active');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [filters, setFilters] = useState({});

  // Періоди (навчальні роки), доступні по цьому садочку — беремо з уже
  // завантажених груп (в т.ч. групи наступного року, куди вже могли
  // перевести частину дітей).
  const availablePeriods = useMemo(() => {
    const years = Array.from(new Set((groups || []).map(g => +g.periodStartYear))).filter(Boolean);
    years.sort((a, b) => a - b);
    return years.length ? years : [new Date().getFullYear()];
  }, [groups]);

  const [selectedPeriod, setSelectedPeriod] = useState(availablePeriods[0]);

  // Якщо список періодів змінився (напр. дані груп довантажились пізніше,
  // або зʼявилась нова група наступного року) і обраний період вже не серед
  // доступних — переключаємось на найраніший (поточний) період.
  useEffect(() => {
    if (!availablePeriods.includes(selectedPeriod)) {
      setSelectedPeriod(availablePeriods[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availablePeriods]);
  
  
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [staffData, setStaffData] = useState({
    active: [],
    archived: [],
    vacancy: [],
    statistics:{} // Добавляем данные для вкладки вакансий
  });



  const columns = {
    active: [
     
      {
        key: 'lastName',
        label: 'Прізвище',
        sortable: true,
        width: '15%'
      },
      {
        key: 'firstName',
        label: 'Ім\'я',
        sortable: true,
        width: '12%'
      },
      {
        key: 'birth_date',
        label: 'Дата народження',
        sortable: true,
        width: '12%'
      },
      {
        key: 'groupName',
        label: 'Група',
        sortable: true,
        width: '13%'
      },
      {
        key: 'sed',
        label: 'Особливі освітні потреби',
        sortable: true,
        width: '5%'
      },
      {
        key: 'birthCertificateNumber',
        label: 'Номер свідоцтва',
        sortable: true,
        width: '10%'
      },
      {
        key: 'tabelNumber',
        label: 'Табельний номер',
        sortable: true,
        width: '10%'
      },
      {
        key: 'kyivreg',
        label: 'Реєстрація в Києві',
        sortable: true,
        width: '5%'
      },
      {
        key: 'is_card_mr',
        label: 'Картка Киянина',
        sortable: true,
        width: '5%'
      },
      {
        key: 'attnd_mis',
        label: 'Відсутній протягом',
        sortable: true,
        width: '5%'
      }
    ],
    archived: [
      {
        key: 'lastName',
        label: 'Прізвище',
        sortable: true,
        width: '15%'
      },
      {
        key: 'firstName',
        label: 'Ім\'я',
        sortable: true,
        width: '15%'
      },
      {
        key: 'birth_date',
        label: 'Дата народження',
        sortable: true,
        width: '10%'
      },
      {
        key: 'groupName',
        label: 'Група',
        sortable: true,
        width: '10%'
      },
      {
        key: 'zdo_benefit',
        label: 'Пільга в ЗДО',
        sortable: true,
        width: '25%'
      },
      {
        key: 'kitch_benefit',
        label: 'Пільга батьківська оплата',
        sortable: true,
        width: '25%'
      },
      {
        key: 'kitch_benefit1',
        label: '',
        sortable: false,
        width: '0%'
      }
    ],
    vacancy: [
      {
        key: 'positionName',
        label: 'Найменування посади',
        sortable: true,
        width: '35%'
      },
      {
        key: 'positionType',
        label: 'Тип посади',
        sortable: true,
        width: '20%'
      },
      {
        key: 'totalUnits',
        label: 'Всього',
        sortable: true,
        width: '15%'
      },
      {
        key: 'occupiedUnits',
        label: 'Фактично у штаті',
        sortable: true,
        width: '15%'
      },
      {
        key: 'vacantUnits',
        label: 'Вакантних місць',
        sortable: true,
        width: '15%'
      }
    ]
  };

  const loadData = async () => {
    if (!kindergartenId) {
      //toast.error('ID садика не вказано');
      return;
    }


    const transformBenList = (benefitDict, benListKg)=>{


      const out = [];


      const getBenName = (benefit)=>{

        if(!benefit || !benefit.benefitId) return '';
        const benF = benefitDict.find(b=>b._id == benefit.benefitId);

        return benF?.name || '';

      }


      benListKg.forEach(b=>{

        const out_obj = {
          lastName: b.lastName,
          firstName: b.firstName,
          birth_date: (new Date(b['birthDate'])).toLocaleDateString('uk'),
          groupName: b.groupNumber + ' ' + b.groupName,
          zdo_benefit: getBenName(b?.benefits[0] || null),
          kitch_benefit: b.benKitchen?.name || '',
        }
        
        out.push(out_obj);

      });

      return out;

    }

    const transfBenStat = (benefitDict, stat)=>{
      const stat_ben = {};

      Object.keys(stat.kg).forEach(bId=>{
         const benF = benefitDict.find(b=>b._id == bId);
         stat_ben[benF.name] = stat.kg[bId];
      });

      return ({kg: stat_ben, kitchen: stat.kitchen});
    }
    
    setLoading(true);
    try {
      const [childrensListKg, benefitsListKg, benefitsDict] = await Promise.all([
        getListOfChildrensInKG(kindergartenId, selectedPeriod ),
        getBenefitsListKG(kindergartenId, selectedPeriod),
        getBenefits()
      ]);
      
      setStaffData({
        active: childrensListKg.data,
        archived: transformBenList(benefitsDict, benefitsListKg.data),
        vacancy: [],
        statistics:{active: childrensListKg.statistic, archived: transfBenStat(benefitsDict, benefitsListKg.stat)}
      });
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
      //toast.error('Помилка завантаження даних');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [kindergartenId, selectedPeriod]);

  // Скидаємо фільтри при переключенні вкладки — набір колонок інший.
  useEffect(() => {
    setFilters({});
  }, [activeTab]);

  // Функция сортировки
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Для колонок з невеликою кількістю унікальних значень показуємо
  // випадаючий список замість текстового пошуку.
  const columnFilterOptions = useMemo(() => {
    const data = staffData[activeTab] || [];
    const options = {};
    (columns[activeTab] || []).forEach(col => {
      if (!col.sortable) return;
      const distinct = Array.from(
        new Set(
          data
            .map(row => row[col.key])
            .filter(v => v !== undefined && v !== null && v !== '')
        )
      );
      if (distinct.length > 0 && distinct.length <= 8) {
        options[col.key] = distinct.sort((a, b) =>
          `${a}`.localeCompare(`${b}`, undefined, { numeric: true })
        );
      }
    });
    return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffData, activeTab]);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const hasActiveFilters = Object.values(filters).some(v => v !== '' && v !== undefined && v !== null);

  const resetFilters = () => setFilters({});

  // Отфильтрованные данные
  const filteredData = useMemo(() => {
    const data = staffData[activeTab];
    if (!data) return data;

    const activeFilters = Object.entries(filters).filter(
      ([, v]) => v !== '' && v !== undefined && v !== null
    );
    if (!activeFilters.length) return data;

    return data.filter(row =>
      activeFilters.every(([key, value]) => {
        const cellValue = row[key];
        if (cellValue === undefined || cellValue === null) return false;
        return `${cellValue}`.toLowerCase().includes(`${value}`.toLowerCase());
      })
    );
  }, [staffData, activeTab, filters]);

  // Сортированные данные
  const sortedData = useMemo(() => {
    const data = filteredData;
    if (!sortConfig.key || !data) return data;
    
    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      
      // Для числовых значений
      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
      }
      
      // Для строковых значений
      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredData, sortConfig]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleMenuToggle = (index, e) => {
    e.stopPropagation();
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleMenuClose = () => {
    setActiveMenuIndex(null);
  };

  const handleActionSelect = async (actionId, position) => {
    try {
      if (actionId === 'edit') {
       
      } else if (actionId === 'archive') {
        
        await loadData();
        //toast.success('Посаду успішно архівовано!');
      } else if (actionId === 'restore') {
        
        await loadData();
        //toast.success('Посаду успішно відновлено!');
      }
    } catch (error) {
      console.error('Ошибка выполнения действия:', error);
      //toast.error('Помилка виконання дії');
    }
    setActiveMenuIndex(null);
  };

  const handleAddPosition = () => {
    
    
  };

  

  const handleSuccess = () => {
    loadData();
  };

  // Экспорт отчета по вакансиям
  const handleExportVacancy = async (format) => {
    if (!kindergartenId) return;
    
    try {
      setExporting(true);
      
      //toast.success(`Звіт по вакансіям експортовано у форматі ${format.toUpperCase()}`);
    } catch (error) {
      console.error('Error exporting vacancy report:', error);
      //toast.error('Помилка експорту звіту');
    } finally {
      setExporting(false);
    }
  };

  const ActionsMenu = ({ onActionSelect, onClose, position, isArchived }) => {
    const actions = isArchived 
      ? [
          {
            id: 'edit',
            label: 'Редагувати',
            icon: faEdit
          },
          {
            id: 'restore',
            label: 'Поновити з архіву',
            icon: faBoxOpen
          }
        ]
      : [
          {
            id: 'edit',
            label: 'Редагувати',
            icon: faEdit
          },
          {
            id: 'archive',
            label: 'Відправити до архіву',
            icon: faArchive
          }
        ];

    return (
      <div className="actions-dropdown">
        {actions.map((action) => (
          <button
            key={action.id}
            className="dropdown-item d-flex align-items-center gap-2 p-2"
            onClick={() => onActionSelect(action.id, position)}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
              width: '100%',
              textAlign: 'left',
              fontSize: '14px',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <FontAwesomeIcon icon={action.icon} style={{ width: '16px', color: '#6c757d' }} />
            <span style={{ color: '#212529' }}>{action.label}</span>
          </button>
        ))}
        
        <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
          <button
            className="btn btn-sm btn-outline-secondary w-100"
            onClick={onClose}
            style={{ fontSize: '12px' }}
          >
            Скасувати
          </button>
        </div>
      </div>
    );
  };

  // Статистика для разных вкладок
  const statistics = useMemo(() => {
    if (activeTab === 'active') {
      const totalUnits = staffData.active.reduce((sum, position) => sum + parseFloat(position.units), 0);
      return {
        totalUnits: cor2Float(totalUnits),
        totalPositions: staffData.active.length
      };
    } else if (activeTab === 'vacancy') {
      const totals = staffData.vacancy.reduce((acc, item) => ({
        totalUnits: acc.totalUnits + item.totalUnits,
        occupiedUnits: acc.occupiedUnits + item.occupiedUnits,
        vacantUnits: acc.vacantUnits + item.vacantUnits
      }), { totalUnits: 0, occupiedUnits: 0, vacantUnits: 0 });
      
      return {
        totals: {totalUnits: cor2Float(totals.totalUnits), occupiedUnits: cor2Float(totals.occupiedUnits), vacantUnits: cor2Float(totals.vacantUnits) },
        totalPositions: staffData.vacancy.length
      };
    }
    
    return {
      totalPositions: staffData[activeTab]?.length || 0
    };
  }, [staffData, activeTab]);

  // Рендер строки для вакансий
  const renderVacancyRow = (item, index) => (
    <tr key={`${item.positionId}-${index}`}>
      <td>
        <div className="vacancy-position-name">
          <strong>{item.positionName}</strong>
        </div>
      </td>
      <td>
        <span className={`vacancy-type-badge vacancy-type-${item.positionType?.toLowerCase()}`}>
          {item.positionType}
        </span>
      </td>
      <td className="vacancy-number">{item.totalUnits}</td>
      <td className="vacancy-number">{item.occupiedUnits}</td>
      <td className="vacancy-number">
        <span className={item.vacantUnits > 0 ? 'vacancy-highlight' : ''}>
          {item.vacantUnits}
        </span>
      </td>
    </tr>
  );

  const handleEditChild = (data) => {
    if (!onActionSelect) return;
    onActionSelect('edit', data._id, data.groupId, data.tabelNumber, data.typeKitchen);
  };

  // Рендер строки для активных/архивных позиций
  const renderPositionRow = (data, index) => (

     <tr
       key={data._id}
       onClick={() => activeTab === 'active' && handleEditChild(data)}
       style={{ cursor: activeTab === 'active' ? 'pointer' : 'default' }}
       title={activeTab === 'active' ? 'Відкрити картку дитини' : undefined}
     >

    {columns[activeTab].map(c=>
      <td key={c.key}>
        <div>
          {data[c.key]}
        </div>
      </td>
    )}

    </tr>
  );

  const getSumOfBen = ()=>{
    const num_kg = Object.keys(staffData.statistics['archived']['kg']).reduce((a,c)=>a + staffData.statistics['archived']['kg'][c], 0);
    const num_kt = Object.keys(staffData.statistics['archived']['kitchen']).reduce((a,c)=>a + staffData.statistics['archived']['kitchen'][c], 0);

    return ` • з пільгами по садочку: ${num_kg}, з пільгами по харчуванню: ${num_kt}`
  }

  return (
    <>
      <main className="queuetable-main-content queuetable-page">
        <div className="container-fluid">
          <div className="queuetable-content-wrapper">
            {/* Панель табов */}
            <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <span className="queuetable-label text-white-50">Загальна інформація по садочку</span>
                {availablePeriods.length > 1 && (
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 'auto' }}
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(+e.target.value)}
                    title="Навчальний рік"
                  >
                    {availablePeriods.map(p => (
                      <option key={p} value={p}>{p}-{p + 1} н.р.</option>
                    ))}
                  </select>
                )}
                <ul className="queuetable-year-tabs nav nav-tabs">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                      onClick={() => setActiveTab('active')}
                    >
                      Діти ({staffData.active.length})
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === 'archived' ? 'active' : ''}`}
                      onClick={() => setActiveTab('archived')}
                    >
                      <FontAwesomeIcon icon={faUsers} className="me-1" />
                      Пільги ({staffData.archived.length})
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === 'vacancy' ? 'active' : ''}`}
                      onClick={() => setActiveTab('vacancy')}
                    >
                      <FontAwesomeIcon icon={faUsers} className="me-1" />
                      Табель
                    </button>
                  </li>
                  
                </ul>
              </div>
              
              <div className="d-flex align-items-center gap-3">
                {/* Статистика */}
                {activeTab === 'active' && (
                  <div className="text-white small">
                    <strong>Всього штатних одиниць: {statistics.totalUnits}</strong>
                  </div>
                )}
                
                {activeTab === 'vacancy' && (
                  <div className="text-white small">
                    <strong>Вакантних одиниць: {statistics.vacantUnits}</strong>
                  </div>
                )}
                
                {/* Кнопки действий */}
                
                
                {false && activeTab === 'vacancy' && (
                  <div className="dropdown">
                    <button
                      className="btn btn-primary btn-sm dropdown-toggle d-flex align-items-center gap-2"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      disabled={exporting || staffData.vacancy.length === 0}
                    >
                      <FontAwesomeIcon icon={faDownload} />
                      Експорт
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <button
                          className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => handleExportVacancy('csv')}
                          disabled={exporting}
                        >
                          <FontAwesomeIcon icon={faFileCsv} />
                          CSV формат
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => handleExportVacancy('xlsx')}
                          disabled={exporting}
                        >
                          <FontAwesomeIcon icon={faFileExcel} />
                          Excel формат
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
                
                <button 
                  className="btn btn-sm btn-outline-light"
                  onClick={loadData}
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faSync} className={loading ? 'fa-spin' : ''} />
                </button>
              </div>
            </div>

            {/* Таблица */}
            <div className="card queuetable-table-card">
              <div className="card-body p-0">
                {loading ? (
                  <div className="text-center p-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Завантаження...</span>
                    </div>
                    <div className="mt-2">Завантаження даних...</div>
                  </div>
                ) : activeTab !== 'vacancy' ? (
                  <>
                   {activeTab == 'archived' && 
                    <div>
                      
                      <div className="table-responsive" style={{minHeight: '0px', paddingBottom: '100px' }}>
                        <table className="table queuetable-table align-middle mb-0">
                          <thead>
                          <tr>
                           <th style={{width: '30%'}} >Пільга</th>
                           <th style={{width: '15%'}} >Тип</th>
                           <th style={{width: '25%'}} >Кількість</th> 
                          </tr>
                          </thead>
                          <tbody>
                             {Object.keys(staffData.statistics['archived']['kg']).map(b=><tr>
                              <td>{b}</td>
                              <td>В садочку</td>
                              <td>{staffData.statistics['archived']['kg'][b]}</td>
                             </tr>)}

                             {Object.keys(staffData.statistics['archived']['kitchen']).map(b=><tr>
                              <td>{b}</td>
                              <td>По харчуванню</td>
                              <td>{staffData.statistics['archived']['kitchen'][b]}</td>
                             </tr>)}
                          </tbody>
                        </table>

                        </div>
                      </div>
                    }
                    <div className="table-responsive">
                      <table className={`table queuetable-table children-list-table align-middle mb-0 ${activeTab === 'active' ? 'table-hover' : ''}`}>
                        <colgroup>
                          {columns[activeTab]?.map((column) => (
                            <col key={column.key} style={{ width: column.width }} />
                          ))}
                        </colgroup>
                        <thead>
                          <tr>
                            {columns[activeTab]?.map((column) => (
                              <th 
                                key={column.key}
                                onClick={() => column.sortable && handleSort(column.key)}
                                className={column.sortable ? 'sortable-column' : ''}
                              >
                                <div className="d-flex align-items-center">
                                  {column.label}
                                  {column.sortable && (
                                    <FontAwesomeIcon 
                                      icon={getSortIcon(column.key)} 
                                      className="ms-1" 
                                      style={{ fontSize: '12px', opacity: 0.7 }}
                                    />
                                  )}
                                </div>
                              </th>
                            ))}
                          </tr>
                          <tr className="children-filters-row">
                            {columns[activeTab]?.map((column) => (
                              <th key={`filter-${column.key}`} style={{ width: column.width }} onClick={(e) => e.stopPropagation()}>
                                {column.sortable && (
                                  columnFilterOptions[column.key] ? (
                                    <select
                                      className="form-select form-select-sm"
                                      style={{ width: '100%', boxSizing: 'border-box', display: 'block' }}
                                      value={filters[column.key] || ''}
                                      onChange={(e) => handleFilterChange(column.key, e.target.value)}
                                    >
                                      <option value="">Всі</option>
                                      {columnFilterOptions[column.key].map(opt => (
                                        <option key={opt} value={opt}>{opt}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      style={{ width: '100%', boxSizing: 'border-box', display: 'block' }}
                                      placeholder="Пошук..."
                                      value={filters[column.key] || ''}
                                      onChange={(e) => handleFilterChange(column.key, e.target.value)}
                                    />
                                  )
                                )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {sortedData && sortedData.length > 0 ? (
                            sortedData.map((item, index) => 
                              activeTab === 'vacancy' 
                                ? renderVacancyRow(item, index)
                                : renderPositionRow(item, index)
                            )
                          ) : (
                            <tr>
                              <td colSpan={columns[activeTab]?.length || 7} className="text-center py-4 text-muted">
                                {activeTab === 'active' && 'Немає активних посад'}
                                {activeTab === 'vacancy' && 'Немає даних про вакансії'}
                                {activeTab === 'archived' && 'Немає даних про пільги (тимчасово)'}
                              </td>
                            </tr>
                          )}
                          
                          {/* Строка итогов для вакансий */}
                          {activeTab === 'vacancy' && sortedData && sortedData.length > 0 && (
                            <tr className="vacancy-total-row">
                              <td colSpan="2">
                                <strong>Всього по садочку:</strong>
                              </td>
                              <td className="vacancy-number">
                                <strong>{statistics.totalUnits}</strong>
                              </td>
                              <td className="vacancy-number">
                                <strong>{statistics.occupiedUnits}</strong>
                              </td>
                              <td className="vacancy-number">
                                <strong className={statistics.vacantUnits > 0 ? 'vacancy-highlight' : ''}>
                                  {statistics.vacantUnits}
                                </strong>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Пагинация и статистика */}
                    <div className="d-flex align-items-center justify-content-between mt-4 queuetable-pagination-wrapper">
                      <div className="queuetable-pagination-info">
                        Всього {statistics.totalPositions} {getPositionLabel(activeTab)}
                        {hasActiveFilters && (
                          <span className="ms-2">• відфільтровано: {sortedData?.length || 0}</span>
                        )}
                        {activeTab === 'active' && 
                          staffData.statistics && 
                          staffData.statistics['active'] &&
                          staffData.statistics['active']['kyivreg'] && (
                            <span className="ms-2">• зареєстровано в Києві: {staffData.statistics['active']['kyivreg']}, мають муніципальну картку: {staffData.statistics['active']['munic']}, є потреба в особливих освітніх умовах: {staffData.statistics['active']['spec_educ']} </span>
                          )
                        }
                        {activeTab === 'archived' && getSumOfBen()}
                        {activeTab === 'vacancy' && statistics.vacantUnits > 0 && (
                          <span className="ms-2">• {statistics.vacantUnits} вакантних одиниць</span>
                        )}
                      </div>
                      {hasActiveFilters && (
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={resetFilters}
                        >
                          Скинути фільтри
                        </button>
                      )}
                    </div>
                  </>
                ) : <StatisticaAttendance kgId={kindergartenId} groups={groups} kgGroup={0} periodStartYear={selectedPeriod} isArchive={false}/>
              }
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Модальное окно редактирования должности */}
      

      {/* Toast уведомления */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

// Вспомогательная функция для подписей
const getPositionLabel = (tab) => {
  switch (tab) {
    case 'active': return 'дітей';
    case 'vacancy': return 'дітей';
    case 'archived': return 'дітей';
    default: return 'записів';
  }
};

export default ListChildrenSKG;